import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {ModalRef} from "../../../tandem-core/models/modal-ref";
import {Goal} from "../../../dashboard/models/goal";
import {FinancialPositionService} from "../../services/financial-position.service";
import {ProposedChange} from "../../models/proposed-change";
import {GoalService} from "../../../dashboard/services/goal.service";
import {Timestamp} from "firebase/firestore";
import {DateService} from "../../../tandem-core/services/date.service";
import {DialogService} from "../../../tandem-core/services/dialog.service";

@Component({
  selector: 'tandem-create-goal-from-pc-form',
  templateUrl: './create-goal-from-pc-form.component.html',
  styleUrls: ['./create-goal-from-pc-form.component.scss']
})
export class CreateGoalFromPcFormComponent implements OnInit {

  formGroup: FormGroup = new FormGroup<any>({});
  proposedChanges: ProposedChange[] = [];
  userId: string = '';
  public modalRef?: ModalRef;

  constructor(private dateService: DateService,
              private fb: FormBuilder,
              private financialPositionService: FinancialPositionService,
              private goalService: GoalService,
              private dialog: DialogService) {
    this.proposedChanges = this.modalRef?.data.proposedChanges;
    this.userId = this.modalRef?.data.userId;
  }
  ngOnInit(): void {
    this.formGroup = this.fb.group({deadline: [null]});
  }

  async createGoals() {
    const addGoalPromises = this.proposedChanges.map(async proposedChange => {
      const goalName = this.financialPositionService.getMessage(proposedChange);

      // Check if a goal with the same name already exists
      const existingGoal = await this.goalService.findByName(goalName, this.userId);
      if (existingGoal) {
        console.log(`Goal with name '${goalName}' already exists.`);
        return Promise.resolve(null); // Resolve the promise with null if goal exists
      }

      const currentDate = new Date();
      const deadlineDate = new Date(this.formGroup.get('deadline')?.value);
      const timeDifference = deadlineDate.getTime() - currentDate.getTime();
      const daysDifference = timeDifference / (1000 * 3600 * 24); // convert milliseconds to days

      let goalType: "Short-Term" | "Mid-Term" | "Long-Term" = "Short-Term";
      if (daysDifference <= 30) {
        goalType = "Short-Term";
      } else if (daysDifference > 30 && daysDifference <= 90) {
        goalType = "Mid-Term";
      } else if (daysDifference > 90 && daysDifference <= 365) {
        goalType = "Long-Term";
      }

      return this.goalService.add({
        name: goalName,
        userId: this.userId,
        dateCreated: Timestamp.now(),
        dateModified: Timestamp.now(),
        startDate: Timestamp.now(),
        targetDate: this.dateService.getAdjustedTimestampFromDate(deadlineDate),
        completed: false,
        type: goalType
      });
    });

    // Wait for all add goal promises to resolve
    const results = await Promise.all(addGoalPromises);
    const addedGoals = results.filter(result => result !== null);

    if (addedGoals.length > 0) {
      this.modalRef?.close({saved: true});
      this.dialog.openMessageDialog('Successfully Created Goals', `We successfully saved ${addedGoals.length} goals based on your action items.`);
    } else {
      this.dialog.openMessageDialog('No New Goals', 'No new goals were created as they already exist.');
    }
  }

  closeModal() {
    this.modalRef?.close();
  }
}
